import gsap from 'gsap'
import { domReady } from '../../helpers'

export default class {
  constructor(el) {
    this.DOM = {}

    this.DOM.el = el

    this.type = el.dataset.jsAnimate
    this.ease = el.dataset.jsEase || 'power4.out'
    this.delay = el.dataset.jsDelay || 0
    this.offset = el.dataset.jsOffset || 20
    this.duration = el.dataset.jsDuration || 2
    this.threshold = el.dataset.jsThreshold || 0.1

    this.animated = false;
    this.reduce = false;

  }

  init() {
    this.a11y()

    domReady().then(() => {
      if(!this.reduce) {
        import('bounds.js').then((x) => {
          this.bounds = new x.default({threshold: this.threshold})
          this.bounds.watch(this.DOM.el, () => {
            if(!this.animated) {
              this.handleAnimation()
            } else {
              this.bounds.clear()
            }
          }, () => {})
        })
      }
    })
  }

  a11y() {
    this.mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleReduceMotion()

    try {
      // Chrome & Firefox
      this.mediaQuery.addEventListener('change', (e) => {
        this.handleReduceMotion()
      });
    } catch (e1) {
      try {
        // Safari
        this.mediaQuery.addListener((e) => {
          this.handleReduceMotion()
        });
      } catch (e2) {
        console.error(e2);
      }
    }
  }

  handleReduceMotion() {
    if (this.mediaQuery.matches) {
      this.reduce = true;
      gsap.set(this.DOM.el, {autoAlpha: 1})
    }
  }

  handleAnimation() {
    setTimeout(() => {
      if(typeof this[this.type] == 'undefined') {
        this.inUp()
      } else {
        this[this.type]()
      }

      this.animated = true;
    }, 50);
  }

  inUp() {
    gsap.fromTo(this.DOM.el, {
      opacity: 0,
      y: this.offset
    }, {
      opacity: 1,
      y: 0,
      duration: this.duration,
      delay: this.delay,
      ease: this.ease,
      clearProps: 'transform'
    })
  }

  fade() {
    gsap.fromTo(this.DOM.el, {
      opacity: 0
    }, {
      opacity: 1,
      duration: this.duration,
      delay: this.delay,
      ease: this.ease,
      clearProps: 'transform'
    })
  }

  inDown() {
    gsap.fromTo(this.DOM.el, {
      opacity: 0,
      y: -this.offset
    }, {
      opacity: 1,
      y: 0,
      duration: this.duration,
      delay: this.delay,
      ease: this.ease,
      clearProps: 'transform'
    })
  }

  inLeft() {
    gsap.fromTo(this.DOM.el, {
      opacity: 0,
      x: this.offset
    }, {
      opacity: 1,
      x: 0,
      duration: this.duration,
      delay: this.delay,
      ease: this.ease,
      clearProps: 'transform'
    })
  }

  inRight() {
    gsap.fromTo(this.DOM.el, {
      opacity: 0,
      x: -this.offset
    }, {
      opacity: 1,
      x: 0,
      duration: this.duration,
      delay: this.delay,
      ease: this.ease,
      clearProps: 'transform'
    })
  }

  destroy() {

  }
}
